/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomerCoupon2Customer, CustomerCouponAdapter, CustomerCouponConnector } from '@spartacus/core';

@Injectable({
   providedIn: 'root',
})
export class SikoB2bCustomerCouponConnector extends CustomerCouponConnector {
   constructor(protected adapter: CustomerCouponAdapter) {
      super(adapter);
   }

   // overriden because of feature toggle - enableClaimCustomerCouponWithCodeInRequestBody
   override claimCustomerCoupon(userId: string, couponCode: string): Observable<CustomerCoupon2Customer> {
      return this.adapter.claimCustomerCoupon(userId, couponCode);
   }
}
